<div class="modal-header">
    <h4 class="modal-title">Archivos de: <strong>{{ dataSent.projectName }}</strong></h4>
    <button type="button" class="btn-close" mat-dialog-close></button>
</div>
<mat-dialog-content>
    <div class="modal-body">
        <h6 class="pb-4">
            <span class="align-middle">Cargar archivos de diagramación:</span>
        </h6>
        <form [formGroup]="form">
            <ngx-file-drag-drop 
                class="ngx-file_f" 
                emptyPlaceholder="Arrastre o seleccione archivos" 
                formControlName="blob" 
                [formControl]="fileControl"
                [multiple]="true"
                accept="image/*,video/*,.pdf"
                (valueChanged)="onValueChange($event)">
            </ngx-file-drag-drop>
        </form>
    </div>
</mat-dialog-content>
<div class="modal-footer pt-4">
    <button mat-button mat-dialog-close>Cancelar<mat-icon>close</mat-icon></button>
    <button mat-flat-button class="btn bg-success text-white" form="" (click)="uploadFile()" type="submit">Cargar Archivo <mat-icon>upload</mat-icon></button>
</div>
